/** @jsxImportSource @emotion/react */
import { css } from "@emotion/react";

import React, { SetStateAction } from "react";

import { useTranslation } from "react-i18next";

import Button, {
  BUTTON_COLORS,
  BUTTON_SIZES,
  BUTTON_VARIANTS
} from "@/components/Button/Button";
import Dialog from "@/components/Dialog/Dialog";
import { DialogWidth } from "@/components/Dialog/types/enums";

interface MoveCompanyErrorDialogProps {
  isOpen: boolean;
  setIsErrorDialogOpen: (value: SetStateAction<boolean>) => void;
}

const MoveCompanyErrorDialog = ({
  isOpen,
  setIsErrorDialogOpen
}: MoveCompanyErrorDialogProps) => {
  const { t } = useTranslation();

  const handleClose = () => setIsErrorDialogOpen(false);

  return (
    <Dialog
      data-testid="move-company-confirm-dialog"
      title={t(`Dialog##move company##error dialog##title`)}
      description={t(`Dialog##move company##error dialog##description`)}
      extendToMaxWidth
      width={DialogWidth.TinyWidth}
      css={css({
        "& .MuiDialog-paper": {
          minWidth: DialogWidth.TinyWidth
        }
      })}
      open={isOpen}
      close={handleClose}
      actions={
        <div
          css={css({
            display: "flex",
            flexDirection: "column-reverse",
            gap: "8px"
          })}
        >
          <Button
            data-testid="move-company-error-dialog-close-btn"
            fullWidth
            color={BUTTON_COLORS.Secondary}
            size={BUTTON_SIZES.Normal}
            variant={BUTTON_VARIANTS.TextOnly}
            onClick={handleClose}
          >
            {t("Button##back")}
          </Button>
        </div>
      }
    />
  );
};

export default MoveCompanyErrorDialog;
